import { MessageService, SelectItem } from 'primeng/api';
import { EventEmitter} from '@angular/core';
import { RoleUserMSService } from './../../../../services/utils/roleUserMS.service';
import { LoyaltyReasonService } from './../../../../services/loyalty/reason.service';
import { AuthService } from './../../../../services/user/auth.service';
import { CustomerInfoService } from './../../../../services/customer/customerinfo.service';
import { DatePipe } from '@angular/common';
import { CalendarTranslateService } from './../../../../modules/UIKit/services/calendarTranslate.service';
import { CustomerListModel } from './../../../../models/customer.model';
import { Acm } from './../../../../models/loyalty-acm.model';
import { DivisionService } from './../../../../services/division/division.service';
import { Component, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LoyaltyMovementService } from '../../../../services/loyalty/loyalty-movement.service';
import { LoyaltyAcmService } from '../../../../services/loyalty/loyalty-acm.service';
import { Observable } from 'rxjs/Observable';
import { StoreCommonService } from '../../../../services/store/store-common.service';
import { ManualMovementDto, Movement } from '../../../../models/loyalty-movement.model';
import { LoyaltyCardService } from '../../../../services/loyalty/loyalty-card.service';
import * as moment from 'moment';
import { AcmTypeHasReasonService } from '../../../../services/loyalty/acm-type-has-reason.service';
import { CustomersService } from '../../../../services/customer/customers.service';
import { LoyaltyParamsService } from '../../../../services/loyalty/params.service';
import { FormValidationService } from '../../../../services/utils/form-validation.service';
import { ApiMethods, PermissionConfiguration } from '../../../../models/permission.model';
import { PermsService } from '../../../../services/utils/perms.service';
import { AcmTypehasReason } from 'app/models/loyalty-acm-type.model';
import { Card } from './../../../../models/loyalty-card.model';

@Component({
  selector: 'app-form-movement-loyalty',
  templateUrl: './form-movement-loyalty.component.html',
  styleUrls: ['./form-movement-loyalty.component.css'],
  providers: [CustomersService]
})
export class FormMovementLoyaltyComponent implements OnInit {

  @Input() movementId: string;
  @Input() editMode: boolean;
  @Input() readonly: boolean;

  /*
  questo parametro viene passato in questi seguenti casi:
   - pulsante movimenti da lista carte loyalty
   - pulsante movimenti da lista carte customer (terzo tab)
   */
  @Input() card_id: number = 0;

  @Output() onSaved = new EventEmitter<any>();
  @Output() onCardNotFound: EventEmitter<boolean> = new EventEmitter();


  ready = {
    form: false,
    form2: false,
    selectCardSource: false
  }

  reasons: Array<{ value: number, label: string, type_pid: any, sign_pid: any }>;
  stores: Array<any>;
  divisions: Array<{ value: number, label: string }>;
  cards: Array<any>;
  listAcm: Array<Acm>;
  customers: Array<CustomerListModel>;
  fields: any;
  texts: any;
  form: FormGroup;
  isPremio: boolean;
  signValue: string;
  radioSelectedFirst: string;
  invalidSubmit: boolean;
  cardId: number = 0;
  cardNo: string = '';
  customerId: number = 0;
  storesVisibility: any = null;
  isCardInputPresent = false;
  insertedOnce = false;
  today = new Date();

  model = {
    store: null,
    card_no_select: null,
    customer_name: null
  }

  disabled = {
    reason: true,
    item_code: true,
    ean: true,
    discount: true,
    store: true
  }

  termId: any;
  actionType: any;

  selected = {
    card: null,
    acm: null,
    customer: null,
    division: null,
    reason: null
  }

  acmtypehasreason: AcmTypehasReason[] = [];
  storeCode: string = '';
  reasonCode: string = '';
  acmCode: string = '';

  // Switch tra componenti generali e componenti specifici
  public customerMgPermission: boolean;
  public customerMgPermissionCheck: PermissionConfiguration;

  searchType = '';

  divisionFieldDisabled: boolean;
  channelId: any = '';
  storeFilters = [];
  selectedStore: any;

  public customerHideInfoCheck: PermissionConfiguration;
  public customerHideInfoPermission: boolean;

  constructor(
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private movementService: LoyaltyMovementService,
    private acmService: LoyaltyAcmService,
    private storeService: StoreCommonService,
    private cardService: LoyaltyCardService,
    private reasonAcmTypeService: AcmTypeHasReasonService,
    private reasonService: LoyaltyReasonService,
    private paramService: LoyaltyParamsService,
    private customerService: CustomersService,
    private calendarTranslate: CalendarTranslateService,
    private divisionService: DivisionService,
    private datePipe: DatePipe,
    private customerInfoService: CustomerInfoService,
    private authService: AuthService,
    private messageService: MessageService,
    private permSrv: PermsService
  ) {
    this.customerMgPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-mg',
      method: ApiMethods.GET
    };
    this.customerHideInfoCheck = {
      ms_base: 'koncentro-loyalty',
      operation: 'customer-hide-info',
      method: ApiMethods.GET
    };
  }

  ngOnInit() {
    this.permSrv.check(this.customerHideInfoCheck).subscribe(res => {
      this.customerHideInfoPermission = res;
      console.log(this.customerHideInfoPermission)
     });

    this.cardId = 0;
    this.cardNo = '';
    this.customerId = 0;
    this.storesVisibility = null;
    this.customerMgPermission = false;

    //Caso passaggio card_id tramite url
    if (this.activatedRoute.snapshot.queryParams['card_id']) {
     this.card_id = this.activatedRoute.snapshot.queryParams['card_id'];
    }


    /*
    CANCELLARE SE SI IMPLEMENTA LA PRIMA SCELTA CON I RADIO BUTTON,
    cioè una modalità per decidere a monte se si sta facendo un movimento da parte dell'utente collegato o da parte di un altro utente.
    Questa scelta dovrà avvenire prima della scelta della ricarca se per carta o customer.
    Allo stato attuale è predisposto, ma non è implementato.
    */
    //this.radioSelectedFirst = "self";

    this.stores = [];
    this.cards = [];
    this.reasons = [];
    this.divisions = [];
    this.listAcm = [];

    this.reasons.push({ label: '', value: null, type_pid: null, sign_pid: null });
    this.divisions.push({ label: '', value: null });

    this.movementId = this.activatedRoute.snapshot.params['movementId'];
    this.editMode = (typeof this.movementId !== 'undefined');

    if(this.activatedRoute.snapshot.data.readonly){
      this.readonly = this.activatedRoute.snapshot.data.readonly;
      this.editMode = !this.readonly;
    }

    this.translate.get([
      'movement.acm_id',
      'movement.card_id',
      'movement.customer_id',
      'movement.reason_id',
      'movement.division_id',
      'movement.card_no',
      'movement.store_id',
      'movement.term_id',
      'movement.action_type',
      'movement.xact_id',
      'movement.sequence_id',
      'movement.xact_date',
      'movement.xact_time',
      'movement.operator_id',
      'movement.value',
      'movement.value2',
      'movement.previous_balance',
      'movement.previous_balance_2',
      'movement.obj_code',
      'movement.object_value',
      'movement.ean',
      'movement.qty',
      'movement.promo_code',
      'movement.item_code',
      'movement.add_title',
      'movement.edit_title',
      'movement.details_title',
      'movement.searchType',
      'movement.movementType',
      'movement.self_store',
      'movement.other_store',
      'movement.positive_value',
      'movement.negative_value',
      'movement.saved_ok',
      'movement.saved_fail',
      'common.storeChannelLoyalty',
      'movement.cardLimitCharacters',
      'movement.positiveValue',
      'movement.negativeValue',
      'movement.store',
      'movement.cash_desk'
    ]).subscribe((translations) => {

      this.texts = {
        acm_id: translations['movement.acm_id'],
        card_id: translations['movement.card_id'],
        customer_id: translations['movement.customer_id'],
        reason_id: translations['movement.reason_id'],
        division_id: translations['movement.division_id'],
        card_no: translations['movement.card_no'],
        store_id: translations['movement.store_id'],
        term_id: translations['movement.term_id'],
        action_type: translations['movement.action_type'],
        xact_id: translations['movement.xact_id'],
        sequence_id: translations['movement.sequence_id'],
        xact_date: translations['movement.xact_date'],
        xact_time: translations['movement.xact_time'],
        operator_id: translations['movement.operator_id'],
        value: translations['movement.value'],
        value2: translations['movement.value2'],
        previous_balance: translations['movement.previous_balance'],
        previous_balance_2: translations['movement.previous_balance_2'],
        obj_code: translations['movement.obj_code'],
        object_value: translations['movement.object_value'],
        ean: translations['movement.ean'],
        qty: translations['movement.qty'],
        promo_code: translations['movement.promo_code'],
        item_code: translations['movement.item_code'],
        add_title: translations['movement.add_title'],
        edit_title: translations['movement.edit_title'],
        details_title: translations['movement.details_title'],
        searchType: translations['movement.searchType'],
        movementType: translations['movement.movementType'],
        self_store: translations['movement.self_store'],
        other_store: translations['movement.other_store'],
        channel_name: translations['common.storeChannelLoyalty'],
        positive_value: translations['movement.positive_value'],
        negative_value: translations['movement.negative_value'],
        saved_ok: translations['movement.saved_ok'],
        saved_fail: translations['movement.saved_fail'],
        cardLimitCharacters: translations['movement.cardLimitCharacters'],
        positiveValue: translations['movement.positiveValue'],
        negativeValue: translations['movement.negativeValue'],
        store: translations['movement.store'],
        cash_desk:translations['movement.cash_desk']
      };

      this.movementService.getFields().subscribe(res => this.fields = res);

      let movement: Observable<any>;
      let MovementParam: Observable<any>;
      let ActionTypeParam: Observable<any>;
      let Division: Observable<any>;
      let Stores: Observable<any>;
      let ObCustomerMg: Observable<any>;

      if (this.activatedRoute.snapshot.data.readonly) {
        //caso read o edit
        movement = this.movementService.get(this.movementId);
      } else {
        movement = Observable.of(new Movement());
      }

      const paramSearchTermId = [
        { key: 'param_group', value: 'ManualMovement' },
        { key: 'param_functional_code', value: 'TERMID' }
      ];

      const paramSearchActionType = [
        { key: 'param_group', value: 'ManualMovement' },
        { key: 'param_functional_code', value: 'ACTIONTYPE' }
      ];

      MovementParam = this.paramService.list(0, 10, paramSearchTermId);
      ActionTypeParam = this.paramService.list(0, 10, paramSearchActionType);
      Division = this.divisionService.getAll();
      Stores = this.storeService.list(0, 9999);
      ObCustomerMg = this.permSrv.check(this.customerMgPermissionCheck);
      const self= this;
      Observable.zip(movement,
        MovementParam,
        ActionTypeParam,
        Division,
        Stores,
        ObCustomerMg
      )
        .subscribe(([res,
          movementParam,
          actionParam,
          resDivision,
          resStores,
          resCustomerMg
        ]) => {

          // Verifico in questo modo se ambiente Gabrielli per evitare problemi di asincronie
          self.customerMgPermission = resCustomerMg;

          if(self.card_id>0){
            const self2= self;
            self.cardService.list(null, null, [{ 'key': 'cardId', 'value': this.card_id.toString() }])
            .subscribe(res => {

              if(res && res.data && res.data.length>0){
                self2.cards.push(res.data[0]);
                self2.selected.card = res.data[0];
                //forse c'è già qui
                self2.cardIdSelect(res.data[0]);
                self2.model.card_no_select = res.data[0].card_no + ' - ' + res.data[0].customerDescription;
                self2.cardNo = res.data[0].card_no;
                self2.cardId = this.card_id;
                // Recupero customerId in caso la carta sia preselezionata in apertura
                self2.customerId = this.selected.card.vCustomerId;
              } else {
                self2.onCardNotFound.emit(true);
              }

            });
          }


          if (movementParam.data.length > 0) {
            self.termId = movementParam.data[0];
          }

          if (actionParam.data.length > 0) {
            self.actionType = actionParam.data[0];
          }

          for (const singleDivision of resDivision) {
            self.divisions.push({value: singleDivision.id, label: singleDivision.name});
          }

          if(resStores.data.length == 1){
            self.storesVisibility = {
              storeId: resStores.data[0].id,
              divisionId: resStores.data[0].divisionId,
              code: resStores.data[0].code
            };
          }
          //console.log('this.storesVisibility ', this.storesVisibility);

          // Poichè xact_time torna come stringa, creo una Date con quell'orario per convertirla nel formato voluto
          let xactTime;
          if (res && res.xact_time) {
            xactTime = new Date();
            xactTime.setHours(res.xact_time.substr(0,res.xact_time.indexOf(":")));
            xactTime.setMinutes(res.xact_time.substr(res.xact_time.indexOf(":")+1, 2));
          }
  
          console.log('Data originale:', this.today);
          console.log('Formato attuale:', this.calendarTranslate.pcalendarTranslate.dateFormatFilter);

          self.form = self.fb.group({
            acm_id: [(res && res.acm_id) ? res.acm_id : ''],
            acm_description: [''],
            card_id: [(res && res.card_id) ? res.card_id : ''],
            customer_name: [(res && res.customer_name) ? res.customer_name : ''],
            customer_id: [(res && res.customer_id) ? res.customer_id : ''],
            reason_id: [(res && res.reason_id) ? res.reason_id : ''],
            reason_description: [''],
            channel_name: [''],
            division_id: [(res && res.division_id) ? res.division_id : ''],
            division_description: [''],
            card_no: [(res && res.card_no) ? res.card_no : ''],
            store_id: [(res && res.store_id) ? res.store_id : ''],
            store_name: [(res && res.store_name) ? res.store_name : ''],
            term_id: [(res && res.term_id) ? res.term_id : ''],
            action_type:  [(res && res.action_type) ? res.action_type : ''],
            xact_id: (res && res.xact_id) ? res.xact_id : 0,
            sequence_id: (res && res.sequence_id) ? res.sequence_id : 0,
            xact_date: [new Date()],
            xact_time: [(res && res.xact_time) ? moment(xactTime).format('HH:mm').toString() : ''],
            operator_id: (res && res.operator_id) ? res.operator_id : 0,
            value: [(res && res.value) ? res.value : ''],
            value2: [(res && res.value_2) ? res.value_2 : 0],
            qty: [(res && res.qty) ? res.qty : 0],
            promo_code: [(res && res.promo_code) ? res.promo_code : ''],
            item_code: [(res && res.item_code) ? res.item_code : ''],
            discount: [(res && res.discount) ? res.discount : 0],
            flg_dsc_tot: [(res && res.flg_dsc_tot) ? res.flg_dsc_tot : 0],
            flg_dsc_item: [(res && res.flg_dsc_item) ? res.flg_dsc_item : 0],
            previous_balance: [(res && res.previous_balance) ? res.previous_balance : 0],
            previous_balance_2: [(res && res.previous_balance_2) ? res.previous_balance_2 : 0],
            obj_code: [(res && res.obj_code) ? res.obj_code : ''],
            object_value: [(res && res.object_value) ? res.object_value : 0],
            ean: [(res && res.ean) ? res.ean : ''],
            flg_manual:  [(res && res.flg_manual) ? res.flg_manual : 1],
          });
       

  
          if(this.storesVisibility && this.storesVisibility.divisionId){
            this.form.controls.division_id.setValue(this.storesVisibility.divisionId);
            this.storeCode = this.storesVisibility.code;
            this.divisionIdSelect(this.storesVisibility.divisionId, this.storesVisibility.storeId);
          }

          if(res && res.reason_id){
            this.reasonService.get(res.reason_id).subscribe(res2=>{
              this.form.get('reason_description').setValue(res2.reason_code + ' - ' + res2.description);

              if (res2 != null && res2.type_pid != null) {
                this.paramService.get(res2.type_pid).subscribe(res => {

                  this.paramService.get(res2.sign_pid).subscribe(res=>{
                    this.signValue = res.param_code;
                  });

                  if (res != null) {
                    this.isPremio = res.param_functional_code === 'RETTIFICAPREMIO';
                  }

                });
              }

            });
          }

          if(res && res.acm_id){
            this.acmService.get(res.acm_id).subscribe(res2=>{
              this.form.get('acm_description').setValue(res2.acm_code + ' - ' + res2.description);
            });
          }

          if(res && res.division_id){
            this.divisionService.get(res.division_id).subscribe(res2=>{
              this.form.get('division_description').setValue(res2.code + ' - ' + res2.description);
            });
          }

          if(res && res.store_id){
            this.storeService.get(res.store_id).subscribe(res2=>{
              this.form.get('store_name').setValue(res2.code + ' - ' + res2.name);
            });
          }

          if(res && res.customer_id){
            this.customerService.getCustomerHostById(res.customer_id).subscribe(res2=>{
              if(res2 && res2.length == 1){
                let customerNameString = res2[0].customerCode + ' - ' + res2[0].name + ' ' + res2[0].surname;
                this.form.get('customer_name').setValue(customerNameString);
                this.model.customer_name = customerNameString;
              }
            });
          }

          if(res && res.card_no){
            this.cardService.list(null, null, [{ 'key': 'cardNo', 'value': res.card_no }])
            .subscribe(filtered => {
              let card = filtered.data[0];
              this.form.get('channel_name').setValue(card.channelDescription);
              this.channelId = card.channel_id;
              this.model.card_no_select = card.card_no + ' - ' + card.customerDescription;
            });
          }

          if(this.readonly){
            this.texts['title'] = this.texts['details_title'];
            this.ready.form = true;
            this.ready.form2 = true;
          } else{
            this.texts['title'] = this.texts['add_title'];
            this.resetForm();
            this.ready.form = true;
          }

          // In Gabrielli disabilito campo Division se utente mononegozio
          if (/*this.customerMgPermission &&*/ resStores && resStores.data && resStores.data.length === 1) {
            this.divisionFieldDisabled = true;
            const divisionId = resStores.data[0]['divisionId'];
            this.form.get('division_id').setValue(divisionId);
            // popolamento select degli store
            this.divisionIdSelect({value: divisionId});
          }

        });
    });
  }
  isFormValid(){

    let isValid = true;

    if(this.form.valid){
      if(
        (this.signValue == '+' && (this.form.get('value').value < 0)) ||
        (this.signValue == '-' && (this.form.get('value').value > 0))
        )
        {
          //se la reason ha segno positivo e il valore invece è negativo o viceversa, è errore!
          isValid = false;
         }
    }
    else{
      isValid = false;
    }

    return isValid;

  }
  resetForm() {
    this.selected.acm = null;
    this.selected.division = null;

    if(this.searchType == 'card'){
      this.selected.customer = null;
    }
    else if(this.searchType == 'customer'){
      this.selected.card = null;
    }
    else{
      this.selected.customer = null;
      this.selected.card = null;
    }

    this.disabled.reason = true;
    this.disabled.store = true;

    var now = new Date();
    this.form.get('xact_id').setValue(0);

    this.form = this.fb.group({
      acm_id: [''],
      card_id: [''],
      //card_no_select: [''],
      customer_name: [''],
      customer_id: [''],
      channel_name: [''],
      reason_id: [''],
      division_id: [''],
      card_no: [''],
      store_id: [''],
      store_name: [''],
      term_id: (this.termId && this.termId.param_code) ? this.termId.param_code : '',
      action_type: (this.actionType && this.actionType.param_code) ? this.actionType.param_code : '',
      xact_id: [0],
      sequence_id: [0],
      xact_date: [new Date()],
      xact_time: [this.datePipe.transform(now, 'HH:mm')],
      operator_id: 0,
      value: [''],
      value2: [0],
      qty: [0],
      promo_code: [''],
      item_code: [''],
      discount: [0],
      flg_dsc_tot: [0],
      flg_dsc_item: [0],
      previous_balance: [0],
      previous_balance_2: [0],
      obj_code: [''],
      object_value: [''],
      ean: [''],
      flg_manual: [1]
    });


  }
  resetAll(){
    //this.radioSelectedSecond = null;
    this.resetForm();
  }

  filterCardSingle(event) {

    //this.resetForm();
    this.cardService.list(null, null, [{ 'key': 'cardNo', 'value': event.query }])
      .subscribe(filtered => {
        this.cards = filtered.data;
    });
  }

  filterAcmSingle(event) {
    let description = event.query ? { 'key': 'acmDescription', 'value': event.query } : { 'key': null, 'value': null };
    let params = [description, { 'key': 'channel_id', 'value': this.channelId.toString() }]
    //tra i params aggiungere il  channel_id 
    let self = this;
    // KS-7999: filtrare solo gli accumulatori visibili; flg_visible '0' vuol dire visibile
    this.acmService.list(0, 99999, params, null, null, null, '1', '0', '0')
      .subscribe(filtered => {
        self.listAcm = filtered.data;
        for(var i = 0;i<this.listAcm.length;i++){
          self.listAcm[i]['acmCodeDescription'] = self.listAcm[i].acm_code + ' - ' + self.listAcm[i].acmDescription;
        }
      });
  }
  filterCustomerSingle(event) {

    //this.resetForm();
    this.customerService.list(null, null, [{ 'key': 'contactName', 'value': event.query }])
      .subscribe(filtered => {

        for (const cust of filtered.data) {
          this.cards = [];
          //cust["contactCodeName"] = cust["customerCode"] + " - " + cust["contactName"];
          let birth =  new Date(cust['birth_date']);
          let birthString = this.datePipe.transform(birth,this.calendarTranslate.pcalendarTranslate.dateFormatFilter)
          cust['contactCodeName'] =
          (cust['denomination'] ? cust['denomination'] : (cust['contactName']))
          + ' - '
          + birthString
          + (cust['customerCode'] ? (' - ' + cust['customerCode']) : '');
        }

        this.customers = filtered.data;

      });
  }
  divisionIdSelect(event,storeId?){

  /*
    se è valorizzato il parametro storeId vuol dire che proviene dalla carta selezionata
    in questo caso si popolano le options del dropdown dello store e viene valorizzata
    a seconda di storeId preso come parametro proveniente dalla carta
  */

  /*
    se non è valorizzato il parametro storeId, vuol dire che l'utente è andato a selezionare una divisione dal dropdown
    e perciò vengono calcolate le option del dropdown dello store, questa volta non verrà assegnato nessun valore,
    ma l'utente andrà a selezionare un negozio tra le varie options.
  */

    this.selected.division = null;
    this.form.get('store_id').setValue(null);
    this.selectedStore = null;
    this.stores = [];

    let divisionID = 0;

    if(storeId>0){
      divisionID = event;
    }
    else{
      divisionID = event.value;
    }

    let params = [
      { 'key': 'division_id', 'value': divisionID.toString() },
      { 'key': 'salesNetworkNameOrder', 'value': 'true' },
      { 'key': 'city_order', 'value': 'true' },
      { 'key': 'valid', 'value': 'true' }

    ]
    this.storeFilters = params;

    this.storeService.list(null,null, params).subscribe(filtered => {

      this.stores.push({ label: '', value: null });

      if(filtered.data && filtered.data.length > 0){
        for(var i = 0;i<filtered.data.length;i++){
          if(filtered.data[i]['name'] === undefined || filtered.data[i]['name'] === null)
            this.stores.push({ label: filtered.data[i]['host_code'] + ' - --', value: filtered.data[i]['id'] });
          else
            this.stores.push({ label: filtered.data[i]['host_code'] + ' - ' + filtered.data[i]['name']+ ',' + filtered.data[i]['address_1']+ ', ' + filtered.data[i]['city'], value: filtered.data[i]['id'] });
        }
      }

      if (storeId > 0) {
        let storeSelected = filtered.data.filter(f => f.id === storeId);
        this.storeCode = storeSelected && storeSelected.length > 0 ? storeSelected[0]['code'] : '';
        this.form.get('store_id').setValue(storeId);
        this.selectedStore = {label: storeSelected[0]['host_code'] + ' - ' + storeSelected[0]['name'] + ',' + storeSelected[0]['address_1'] + ', ' + storeSelected[0]['city'], value: storeSelected[0]['id']};
        console.log(this.selectedStore)
        this.storeChange(storeId);
      }
      if(event.value){
       this.selected.division = event.value;
      }else{
        this.selected.division = event;
      }
    });
  }
  onCardChange(){

      //let selectedValue = this.form.get('card_no_select').value;
      let selectedValue = this.model.card_no_select;

      for(const card of this.cards){

        if(selectedValue == card.value){

          this.cardService.list(null, null, [{ 'key': 'cardNo', 'value': card.number }])
          .subscribe(filtered => {
            let card = filtered.data[0];
            this.selected.card = card;
            this.cardIdSelect(card);
            this.searchType = 'customer';

          });
        }
      }

  }
  cardIdSelect(card) {

    /*
    A seguito della selezione di una carta, viene recuperato il customer legato alla carta...
    Se ha una company (possono essere n) allora mostra il nome della prima company,
    altrimenti mostra il nome del customer
    */
    //this.ready.form = false;

    this.searchType = 'card';
    this.ready.form2 = true;

    this.form.get('card_no').setValue(card.card_no);
    this.form.get('channel_name').setValue(card.channelDescription);
    this.channelId = card.channel_id;

    //this.form.get('customer_id').setValue(card.custome);

    this.customerService.getCustomerDetailsByCardId(card.id).subscribe(resp => {

      this.form.get('customer_id').setValue(card.vCustomerId);

      if (resp) {
        if (card.isCompany == 'S') {
          this.model.customer_name = resp[0].company_name;
          //this.form.get('customer_name').setValue(resp[0].company_name);
        }
        else {
          //this.form.get('customer_name').setValue(card.customerDescription);
          this.model.customer_name = card.customerDescription;
        }
        //this.form.get('customer_id').setValue(resp[0].customer_id);
      }

      this.form.get('card_id').setValue(card.id);
      this.form.get('division_id').setValue(card.divisionId);

      if (!this.divisionFieldDisabled) {
        this.divisionIdSelect(card.divisionId,card.store_id);
      }

    //  this.ready.form = true;
    });

  }
  acmIdSelect(acm) {
    this.form.get('acm_id').setValue(acm.id);
    this.selected.acm = acm;
    this.acmSelect(acm);
  }
  customerIdSelect(customer) {

    /*
    a seguito della selezione di una customer (ricerca per customer)
    viene reso disponibile il dropdown delle carte a lui associate (elenco card filtrate per customer)
    */

    this.searchType = 'customer';

    this.cards = [];
    var self = this;
    this.selected.customer = customer;
    self.form.get('customer_id').setValue(customer.id);
    self.form.get('customer_name').setValue(customer.denominazione);
    self.ready.form = true;

    this.customerInfoService.getCards(customer.id).subscribe((res) => {

      for (const c of res) {
        this.cards.push({ label: c.cardNo, value: c.cardId, number: c.cardNo, channel: c.channel_id });
      }

    });
  }
  onClearCards(){
    this.searchType = '';
    this.ready.form2 = false;
  }
  onClearCustomer(){
    this.searchType = '';
    this.ready.form2 = false;
  }
  reasonChange(reason) {
    this.form.get('value').setValue(null);
    this.isPremio = false;

    if (reason != null && reason.selectedOption.type_pid != null) {
      this.paramService.get(reason.selectedOption.type_pid).subscribe(res => {

        this.paramService.get(reason.selectedOption.sign_pid).subscribe(res=>{
          this.signValue = res.param_code;
        });

        if (res != null) {
          this.isPremio = res.param_functional_code === 'RETTIFICAPREMIO';
        }

      });
    }

    if(reason !== null && reason.value !== null){
      //console.log('this.acmtypehasreason ', this.acmtypehasreason);
      if(this.acmtypehasreason.length > 0){
        let reasonSelected = this.acmtypehasreason.filter(f => f.reason_id === reason.value);
        this.reasonCode = reasonSelected && reasonSelected.length > 0 ? reasonSelected[0].reasonCode : '';
      }else{
        this.reasonCode = '';
      }
    }else{
      this.reasonCode = '';
    }
  }

  storeChange(storeId?) {
    if (storeId !== undefined) {
      this.storeService.list(null,null, [{ 'key': 'id', 'value': storeId.toString() }]).subscribe(filtered => {
        if (filtered.data && filtered.data.length > 0) {
          this.storeCode = filtered.data[0]['code'];
        } else {
          this.storeCode = '';
        }
      });
    } else {
      this.storeCode = '';
    }
    let card = this.form.get('card_no').value;
    let store = this.form.get('store_id').value;
  }
  acmSelect(acm) {

    this.disabled.reason = true;
    this.form.get('reason_id').setValue(null);
    const acmTypeId = acm.acm_type_id;
    this.acmCode = acm !== undefined && acm !== null ? acm.acm_code : '';

    if (acmTypeId) {

      const params = [{key: 'flg_state', value: '0' }]

      //liste di reason con flg_state = 0
      this.reasonAcmTypeService.getFromAcmType(acmTypeId,params).subscribe(resp => {
        if (resp.data && resp.data.length > 0) {
          this.reasons = [];
          this.acmtypehasreason = resp.data;
          this.reasons.push({ label: '', value: null, type_pid: null, sign_pid: null });
          for (const reason of resp.data) {
            this.reasons.push({ value: reason.reason_id, label: reason.reasonDescription, type_pid: reason.reasonType_pid, sign_pid: reason.reasonSign_pid });
          }
          this.disabled.reason = false;
        }
      });
    }
    this.reasonChange(null);
  }

  onOpenSelectCardSource(){
    this.ready.selectCardSource = true;
  }

  onSourceCardSelected(card: Card){
    //console.log('card ', card);
    //controllo se ha il customerId altrimenti non posso andare avanti
    if(card.vCustomerId){
      this.selected.card = card;
      this.customerId = card.vCustomerId;
      this.cardId = Number(card.id);
      this.cardNo = card.card_no;
      this.model.card_no_select = card.card_no + " - " + card.customerDescription;
      this.form.get('channel_name').setValue(card.channelDescription);
      this.ready.selectCardSource = false;
      this.ready.form2 = true;
      this.isCardInputPresent = true;
      this.insertedOnce = true;
      //KS-6970 aggiunto il channelID che prima non veniva valorizzato alla selezione della carta
      this.channelId = card.channel_id;
    }
    else{
      this.selected.card = null;
      this.cardId = 0;
      this.cardNo = '';
      this.model.card_no_select = null;
      this.form.get('channel_name').setValue(null);
      this.ready.selectCardSource = true;
      this.ready.form2 = false;
      this.isCardInputPresent = false;
      this.messageService.add({severity: 'error', summary: 'Error', detail: this.translate['message_noCustomer']});
    }
  }

  save() {
    console.log(this.form.get('store_id'))
    console.log(this.form.get('store_id').value)
    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    } else {
        let dNow: Date = new Date();
        let dateNow: string = '';
        let timeNow: string = '';
        let termId: number = 0;
        if(this.customerMgPermission){
          dateNow = this.editMode ? this.form.controls.xact_date.value.toString() !== '' ? this.form.controls.xact_date.value.toString() : moment(dNow, 'DD/MM/YYYY').format('MMM D, YYYY h:mm:ss A') : moment(dNow, 'DD/MM/YYYY').format('MMM D, YYYY h:mm:ss A');
          timeNow = this.editMode ? this.form.controls.xact_time.value.toString() !== '' ? this.form.controls.xact_time.value.toString() : moment(dNow, 'h:mm').format('MMM D, YYYY h:mm:ss A') : moment(dNow, 'h:mm').format('MMM D, YYYY h:mm:ss A');
          termId = this.editMode ? this.form.controls.term_id.value.toString() !== '' ? +this.form.controls.term_id.value : 999 : 999;
        }

        const xactTime = this.form.get('xact_time').value;
        let dateFromXactTime = new Date();
        // Se xactTime è stringa, creo una Date con quell'orario per convertirla nel formato voluto
        if (isNaN(Date.parse(xactTime))) {
          dateFromXactTime.setHours(xactTime.substr(0,xactTime.indexOf(":")));
          dateFromXactTime.setMinutes(xactTime.substr(xactTime.indexOf(":")+1, 2));
        } else {
          dateFromXactTime = xactTime;
        }

        this.invalidSubmit = false;
        //#region SVILUPPI PER KS-2631: il back-end controllerà se la chiamata è specifica per Gabrielli o per Koncentro in base al company code che viene passato
        const movement = new Movement();
        movement.acm_id = this.form.get('acm_id').value.id;
        movement.card_id = this.cardId.toString() //this.form.get('card_id').value;
        movement.customer_id = this.customerId //+this.form.get('customer_id').value;
        movement.reason_id = this.form.get('reason_id').value;
        movement.division_id = +this.form.get('division_id').value;
        movement.card_no = this.cardNo //this.form.get('card_no').value;
        movement.store_id = this.form.get('store_id').value;
        movement.term_id = this.customerMgPermission ? termId : +this.form.get('term_id').value;
        movement.action_type = this.form.get('action_type').value;
        movement.xact_date = this.customerMgPermission ? moment(new Date(dateNow)).format('YYYY-MM-DD') : moment(this.form.get('xact_date').value).format('YYYY-MM-DD');
        movement.xact_time = this.customerMgPermission ? moment(new Date(timeNow)).format('HH:mm:ss.SSS') : moment(dateFromXactTime).format('HH:mm:ss.SSS');
        movement.xact_id = 0;
        movement.operator_id = 0; //default
        movement.value = +this.form.get('value').value;
        movement.value2 = +this.form.get('value2').value;
        movement.previous_balance = +this.form.get('previous_balance').value;
        movement.previous_balance_2 = +this.form.get('previous_balance_2').value;
        movement.ean = this.form.get('ean').value;
        movement.discount = this.form.get('discount').value;
        movement.sequence_id = 0; //default
        movement.promo_code = this.form.get('promo_code').value;
        movement.item_code = this.form.get('item_code').value;
        movement.qty = +this.form.get('qty').value;
        movement.flg_dsc_tot = +this.form.get('flg_dsc_tot').value;
        movement.flg_dsc_item = +this.form.get('flg_dsc_item').value;
        movement.flg_manual = +this.form.get('flg_manual').value;
        //console.log('movement ', movement);

        if (this.isPremio) {
          movement.obj_code = movement.ean;
          //movement.obj_code = this.form.get('obj_code').value;
        }

        if(!this.editMode){
          let manualMovementDto = this.formatManualMovement(movement);
          this.movementService.insertManualMovement(manualMovementDto, this.authService.user.selectedCompany).subscribe(() => {
            this.onSaved.emit(movement);
            this.messageService.add({severity: 'success', summary: 'Success', detail: this.fields['saved_ok']});
            if (this.card_id > 0) {
              this.router.navigate(['/loyalty/movement/'], {queryParams: {cardNumber: this.cardNo}});
            } else {
              this.router.navigate(['/loyalty/movement/']);
            }
          });
        }
        //#endregion

        /*if (!this.editMode) {
          this.movementService.create(movement).subscribe(res => {

            if(res){
              if(this.card_id > 0){
                this.onSaved.emit(movement);
                this.messageService.add({severity: 'success', summary: 'Success', detail: this.fields['saved_ok']});
              }else{
                this.router.navigate(['/loyalty/movement/']);
              }
            }
            else{
              this.messageService.add({severity: 'warning', summary: 'Error', detail: this.fields['saved_fail']});
            }
          });
        } else {
          movement.id = this.movementId;
          this.movementService.update(movement).subscribe(res => {
            if(res){
              if(this.card_id > 0){
                this.onSaved.emit(movement);
                this.messageService.add({severity: 'success', summary: 'Success', detail: this.fields['saved_ok']});
              }
              else{
                this.router.navigate(['/loyalty/movement/']);
              }
            }
            else{
              this.messageService.add({severity: 'warning', summary: 'Error', detail: this.fields['saved_fail']});
            }


          });
        }*/

      }

  }

  formatManualMovement(data: Movement): ManualMovementDto{
    let objDTO = new ManualMovementDto();
    objDTO.acm_id = data.acm_id;
    objDTO.card_id = data.card_id;
    objDTO.customer_id = data.customer_id;
    objDTO.reason_id = data.reason_id;
    objDTO.division_id = data.division_id;
    objDTO.card_no = data.card_no;
    objDTO.store_id = data.store_id;
    objDTO.term_id = data.term_id;
    objDTO.action_type = data.action_type;
    objDTO.xact_date = data.xact_date;
    objDTO.xact_time = data.xact_time;
    objDTO.xact_id = data.xact_id;
    objDTO.operator_id = data.operator_id;
    objDTO.value = data.value;
    objDTO.previous_balance = data.previous_balance;
    objDTO.previous_balance_2 = data.previous_balance_2;
    objDTO.ean = data.ean;
    objDTO.sequence_id = data.sequence_id;
    objDTO.promo_code = data.promo_code;
    objDTO.item_code = data.item_code;
    objDTO.qty = data.qty;
    objDTO.flg_dsc_tot = data.flg_dsc_tot;
    objDTO.flg_dsc_item = data.flg_dsc_item;
    objDTO.flg_manual = data.flg_manual;
    objDTO.channel_code = this.selected.card.channelCode;
    objDTO.store_code = this.storeCode;
    objDTO.reason_code = this.reasonCode;
    objDTO.acm_code = this.acmCode;

    return objDTO;
  }

  clearCardSearch() {
    this.ready.form2 = false;
    this.model.card_no_select = null;
    this.isCardInputPresent = false;
    this.resetForm();
  }

  changeStore(event) {
    console.log(event)
    this.form.get('store_id').setValue(event.value)
    this.storeChange(event.value)
    this.selectedStore = event;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-movement/form-movement-loyalty/form-movement-loyalty.component.ts